import { render, staticRenderFns } from "./index2.vue?vue&type=template&id=8ee4ef18&scoped=true"
import script from "./index2.vue?vue&type=script&lang=js"
export * from "./index2.vue?vue&type=script&lang=js"
import style0 from "./index2.vue?vue&type=style&index=0&id=8ee4ef18&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ee4ef18",
  null
  
)

export default component.exports